module.exports = __webpack_public_path__ + "img/icon-login.be3ba076.svg";